import clsx from 'clsx';
import type { ButtonHTMLAttributes, ReactNode } from 'react';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
  active?: boolean;
  children: ReactNode;
}

export function IconButton({
  label,
  active,
  className,
  children,
  ...rest
}: Props): JSX.Element {
  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      aria-pressed={active}
      className={clsx(
        'inline-flex h-8 w-8 items-center justify-center rounded-md border text-muted transition-colors',
        'border-border hover:border-accent hover:text-foreground',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent',
        'disabled:cursor-not-allowed disabled:opacity-50',
        active && 'border-accent bg-accent/10 text-accent',
        className,
      )}
      {...rest}
    >
      {children}
    </button>
  );
}
